<app-segov-sigepo-portal-body>

  <app-segov-sigepo-header-section [Title]="title" [RouteStack]="RouteStack">
  </app-segov-sigepo-header-section>

  <h3 class="default-spacing-title" style="color: var(--tom-1-jornal); font-weight: 600; padding-bottom: 0;"><img width="48px" src="icons/megaphone-line.svg" alt="Ícone de megafone"/>
    Comunicados</h3>
  <h5 class="default-spacing-title">Acompanhe os comunicados sobre a publicação do Jornal</h5>

  <div class="default-spacing-title">
    <div class="mb-3">
      <div class="search-bar-line-bg">
        <lib-segov-sigepo-rounded-search-bar
          [style]="'width: 100%; max-width: 1020px; padding: 0 2rem;'"
          [customInputStyle]="'height: 64px;'"
          [placeholder]="'Informe o termo que deseja pesquisar'"
          [iconeCustom]="'icons/close-circle-line.svg'"
          [customSearchIconStyle]="'color: var(--tom-1-jornal); font-size: x-large'"
          [clearInput] = "apagarTexto"
          [hasSideIcon]="efetouPesquisa"
          (TextChanged)="AtualizaTexto($event)" (keyup.enter)="ListarComunicadosPesquisa()"
          (ClickedFilter)="ListarComunicadosPesquisa()"
          (ClickedClear)="ReiniciarPesquisa()" >
        </lib-segov-sigepo-rounded-search-bar>
        @if(errorMsg){
          <p class="error-message text-center mt-2">{{errorMsg}}</p>
        }
      </div>
    </div>

    <div class="row" style="margin:auto; width: 100%">
      @if(ComunicadosOutputDto && ComunicadosOutputDto.length > 0) {
      @for(comunicado of ComunicadosOutputDto; track $index) {
      <div class="col-12">
        <lib-segov-sigepo-simple-card [titulo]="comunicado.titulo" [subtitulo]="comunicado.dataPublicacaoString"
          [conteudoTexto]="comunicado.conteudo"
          [customTitleStyle]="'font-weight: 600; color: var(--text-geral-fundo-claro)'"
          [customSubTitleStyle]="'color: var(--tom-1-jornal); font-weight: 600'"
          [customBodyStyle]="'color: var(--text-geral-fundo-claro)'"
          >
        </lib-segov-sigepo-simple-card>
      </div>
      }
      } @else {
      <div style="background-color: var(--grey-400); padding: 2rem; border-radius: 2rem; margin: 2rem 0;">
        <span style="color: black">Não foram encontrados comunicados.</span>
      </div>
      }

      @if(PaginaAtual >= 1 && PaginaAtual < TotalPaginas) { <div class="mb-3 mt-4"
        style="display: flex; justify-content: center;">
        <lib-segov-sigepo-rounded-button [baseStyle]="'segov-rounded-button-with-border'" [type]="'button'"
          [width]="'320px'"
          [customStyle]="'border-radius: 5px; background-color: transparent; color: var(--tom-1-jornal); border-color: var(--tom-1-jornal);'"
          (click)="CarregarMaisComunicados()" (keyup.enter)="CarregarMaisComunicados()">
          Carregar mais
        </lib-segov-sigepo-rounded-button>
    </div>
    }
  </div>
  </div>
</app-segov-sigepo-portal-body>
